import React, { useCallback, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Form, Input } from 'antd'
import {
  createUrl,
  getQueryParams,
} from '../../../../core/utils/services/queryParams'

const AliasFilter = () => {
  const history = useHistory()
  const { pathname, search } = useLocation()
  const { alias } = getQueryParams(search)
  const [value, setValue] = useState(alias)

  const onSearch = useCallback(
    alias =>
      history.push(
        createUrl(pathname, search, {
          alias,
        }),
      ),
    [history, pathname, search],
  )

  return (
    <Form.Item
      label="Alias"
      colon={false}
      labelCol={{ span: 24 }}
      wrapperCol={{ span: 24 }}
    >
      <Input.Search
        value={value}
        onChange={({ target: { value } }) => setValue(value)}
        onSearch={onSearch}
        allowClear
      />
    </Form.Item>
  )
}

export default AliasFilter
